import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { Checkbox } from '../../primitives';
import { HeightAnimation } from '../../animations';
import { Text } from '../../new-libby';
export var collapsibleCheckboxKey = 'collapsible-checkbox';
var CollapsibleCheckbox = /** @class */ (function (_super) {
    __extends(CollapsibleCheckbox, _super);
    function CollapsibleCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollapsibleCheckbox.prototype.render = function () {
        var props = this.props;
        var cn = namespacedClassnames(collapsibleCheckboxKey, props.className);
        return (React.createElement("div", { className: cn },
            React.createElement(Checkbox, { value: props.value, onChange: props.onChange, disabled: props.disabled },
                React.createElement(Text, { color: 't20' }, props.label)),
            React.createElement(HeightAnimation, { className: 'collapsible-body', show: props.value }, props.children)));
    };
    return CollapsibleCheckbox;
}(React.PureComponent));
export { CollapsibleCheckbox };
//# sourceMappingURL=index.js.map